<template>
  <div>
    <div class="bg-white shadow-sm rounded-md h-60">
      <div class="border-b-0.5">
        <p class="p-2 text-sm">Clock In</p>
      </div>

      <!-- <transition name="fade">
        <div
          v-if="loading"
          class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
        >
          <loader class="center-h-v" />
        </div>
      </transition> -->

      <transition name="fade">
        <div
          v-if="create_error"
          class="p-1 text-center text-sm w-full bg-yellow-200"
        >
          {{ create_error }}
        </div>
      </transition>

      <transition name="fade">
        <div v-if="success" class="p-1 text-center text-sm w-full bg-green-200">
          {{ success }}
        </div>
      </transition>

      <div class="flex flex-col gap-2 justify-center p-4 items-center">
        <span
          v-if="!isUseClockedIn"
          class="text-center text-4xl font-bold border-0.5 p-3.5 rounded-lg"
          >{{ time }}</span
        >
        <span
          v-if="isUseClockedIn"
          class="text-center text-md font-bold border-0.5 p-3.5 rounded-lg"
          >You clocked in <br />{{ timeSinceClockIn }}</span
        >
        <button
          @click="handleClockIn"
          v-if="!isUseClockedIn"
          class="bg-green-500 text-white rounded-full p-2 text-sm w-3/4 mt-2"
        >
          Clock In
        </button>
        <button
          @click="handleClockOut"
          v-if="isUseClockedIn"
          class="bg-red-500 text-white rounded-full p-2 text-sm w-3/4 mt-2"
        >
          Clock Out
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
// import Loader from "@/components/loader/loader.vue";
export default {
  name: "ClockIn",
  // components: { Loader },
  data() {
    return {
      success: null,
      create_error: null,
      loading: false,
      timeElapsed: null,
      loggedInTime: null,
      latestClockInTimeWithoutClockout: null,
      currTime: moment().format("h:mm:ss A"),
      tableData: [],
    };
  },
  computed: {
    time() {
      return this.upadateTimeAfterOneSecond();
    },
    timeSinceClockIn() {
      return this.updateTimeElapsedSinceClockIn();
    },
    ...mapGetters([
      "getClockInTime",
      "isUseClockedIn",
      "getOrganization",
      "getToken",
      "getLatestClockInTimeWithoutClockout",
    ]),
  },

  created() {
    this.getMyAttendance();
  },
  methods: {
    upadateTimeAfterOneSecond() {
      setInterval(() => {
        this.currTime = moment().format("h:mm:ss A");
      }, 1000);
      return this.currTime;
    },

    async handleClockIn() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        if (navigator.geolocation) {
          const position = await this.getCurrentPosition();
          const { latitude, longitude } = position.coords;

          const response = await axios.post(
            `${this.getOrganization}/attendance/${this.$ApiVersion}/clockin`,
            {
              Location: {
                Latitude: latitude,
                Longitude: longitude,
              },
            },
            options
          );

          this.loading = false;

          if (response.data.StatusCode === 200) {
            this.success = response.data.StatusMessage;
            console.log(response.data);
            this.$store.commit("setClockIn", moment());
            setTimeout(() => {
              this.success = null;
            }, 5000);
            this.getMyAttendance();
          } else {
            this.create_error = response.data.StatusMessage;
            setTimeout(() => {
              this.create_error = null;
            }, 5000);
          }
        } else {
          this.create_error = "Geolocation is not supported by this browser.";
        }
      } catch (error) {
        this.loading = false;
        this.create_error = "An error occurred while processing your request.";
        console.error("Clock-in error:", error);

        setTimeout(() => {
          this.create_error = null;
        }, 5000);
      }
    },

    getCurrentPosition() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
    },

    updateTimeElapsedSinceClockIn() {
      setInterval(() => {
        this.timeElapsed = moment(this.getClockInTime).fromNow();
      }, 1000);

      return this.timeElapsed;
    },
    async handleClockOut() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };

      try {
        if (navigator.geolocation) {
          const position = await this.getCurrentPosition();
          const { latitude, longitude } = position.coords;

          const response = await axios.post(
            `${this.getOrganization}/attendance/${this.$ApiVersion}/clockout`,
            {
              Location: {
                Latitude: latitude,
                Longitude: longitude,
              },
            },
            options
          );

          this.loading = false;

          if (response.data.StatusCode === 200) {
            this.success = response.data.StatusMessage;
            this.getMyAttendance();
            this.$store.commit("clockOut");
            setTimeout(() => {
              this.success = null;
            }, 5000);
          } else {
            this.create_error = response.data.StatusMessage;
            setTimeout(() => {
              this.create_error = null;
            }, 5000);
          }
        } else {
          this.create_error = "Geolocation is not supported by this browser.";
        }
      } catch (error) {
        this.loading = false;
        this.create_error = "An error occurred while processing your request.";
        console.error("Clock-out error:", error);
      }
    },

    getMyAttendance() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/attendance/me/${this.$ApiVersion}/request`,
          options
        )
        .then(
          async (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              // console.log(response);
              this.tableData = response.data;
              console.log(this.tableData);
              const latestClockInTimeWithoutClockout = this.tableData;
              // .find(
              //   (data) =>
              //     data.ClockOutLatitude === null || data.ClockOutTime === null
              // )?.ClockInTime;

              this.$store.commit(
                "setLatestClockInTimeWithoutClockout",
                latestClockInTimeWithoutClockout
              );
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          () => {
            this.loading = false;
          }
        );
    },

    getTime() {
      const diffInMillis =
        new Date() - new Date(this.latestClockInTimeWithoutClockout);
      const diffInSeconds = diffInMillis / 1000;
      const diffInMinutes = diffInSeconds / 60;
      const diffInHours = diffInSeconds / 3600;

      if (diffInSeconds < 60) {
        this.loggedInTime = `${Math.floor(diffInSeconds)} seconds`;
      } else if (diffInMinutes < 60) {
        this.loggedInTime = `${Math.floor(diffInMinutes)} minutes`;
      } else if (diffInHours >= 1) {
        this.loggedInTime = `${Math.floor(diffInHours)} hour${Math.floor(
          diffInHours
        )} > 1 ? 's' : ''`;
      } else {
        this.loggedInTime = "Just logged in.";
      }
    },
  },
};
</script>
